import { createReducer } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

import {
  RECIPIENTS_RESET,
  RECIPIENTS_GET_REQUEST,
  RECIPIENTS_GET_SUCCESS,
  RECIPIENTS_GET_FAILURE,
} from './recipients.const';

export const initialState = {
  model: [],
  meta: {
    status: null,
  },
};

const recipientsReducer = createReducer(initialState, builder => {
  builder
    .addCase(RECIPIENTS_RESET, () => initialState)
    .addCase(RECIPIENTS_GET_REQUEST, (state, { payload = {} }) => {
      state.meta.status = payload.isSearch ? STATUS.UPDATING : STATUS.LOADING;
    })
    .addCase(RECIPIENTS_GET_SUCCESS, (state, { payload = {} }) => {
      state.model = payload.results;
      state.meta.status = STATUS.SUCCESS;
    })
    .addCase(RECIPIENTS_GET_FAILURE, state => {
      state.meta.status = STATUS.ERROR;
    })
    .addDefaultCase(() => {});
});

export default recipientsReducer;
